module.exports = __webpack_public_path__ + "static/media/live06_06_2019.0129f499.jpg";